import { Button } from 'reactstrap';
import { useToggle } from '../../../hooks/useToggle';
import { SharingModal } from './SharingModal';
import { InsightDashboard } from '../../../types/insight-custom-dashboard';

type Props = {
  dashboard: InsightDashboard;
  disabled?: boolean;
};

export const SharingButton = ({ dashboard, disabled }: Props) => {
  const [isOpen, toggle] = useToggle();

  const active = dashboard.share?.some(s => s.enabled);
  const text = active ? 'Shared' : 'Share';
  return (
    <>
      <Button color='secondary' active={active} onClick={toggle} disabled={disabled} className='px-2 ml-2'>
        <i className='fa-light fa-share-from-square fs-6 mr-1' /> {text}
      </Button>
      <SharingModal isOpen={isOpen} toggle={toggle} dashboard={dashboard} />
    </>
  );
};
